import script from "./logout.vue?vue&type=script&lang=ts&setup=true"
export * from "./logout.vue?vue&type=script&lang=ts&setup=true"

import "./logout.vue?vue&type=style&index=0&id=738f90ea&lang=scss&scoped=true"

import exportComponent from "E:\\gitProject\\营城\\yingcheng\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738f90ea"]])

export default __exports__